const _ = require("lodash");

export function parseError(errorResponse) {
  let error = errorResponse.response;
  if (error) {
    let status = error.status;
    let title = error.statusText;
    let detail = "";

    //check for form error
    let attributes = {};
    let errorDetail =
      errorResponse.response.data.errors &&
      errorResponse.response.data.errors.length > 0
        ? errorResponse.response.data.errors[0]
        : undefined;

    if (errorDetail) {
      title = errorDetail.title;
      detail = errorDetail.detail;
    }
    if (errorDetail && errorDetail.source && errorDetail.source.pointer) {
      let attributeName = _.last(errorDetail.source.pointer.split("/"));
      let value = errorDetail.title;
      attributes[attributeName] = _.upperFirst(`${attributeName} ${value}`);
    }
    return { title, detail, status, attributes };
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/epics/lib.js